// third-party
import { FormattedMessage } from "react-intl";
// import { useTranslation } from "react-i18next";
// assets

import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconSettings,
  IconSlideshow,
  IconHome,
  IconHome2,
  IconUser,
  IconGlobe,
  IconKey
} from "@tabler/icons-react"


import { GiPostOffice } from "react-icons/gi";
import { FcDepartment } from "react-icons/fc";
import React, { useState, useEffect, useContext } from "react";

// constant
const icons = {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconSettings
};


// ==============================|| APPLICATION MENU ITEMS ||============================== //

const applicationEcoles = {
  id: "application",
  title: ["C. ",<FormattedMessage id="administrador" />],
  type: "group",
  icon: <IconSettings />, // Use a valid icon component here
  children: [
    
        {
          id: "divers",
          title: <FormattedMessage id="divers" />,
          type: "collapse",
          icon: icons.IconBasket,
          children: [
            {
              id: "annee_academique",
              title: ["1. ", <FormattedMessage id="annee_scolaire" />],
              type: "item",
              url: "/AnneeAcademique",
            },
            {
              id: "annee_academique_inscription",
              title: ["2. ",<FormattedMessage id="annee_scolaire_inscriptionEnligne" />],
              type: "item",
              url: "/AnneeAcademiqueIncription",
            },
            {
              id: "tauxChange",
              title: ["3. ",<FormattedMessage id="monnaie_e_taux" />],
              type: "item",
              url: "/Monnaie",
            },
            {
              id: "cdastrar_iva1",
              title: ["2. ", <FormattedMessage id="cdastrar_iva" />],
              type: "item",
              url: "/IVACadastro",
            },

           /*  {
              id: "mentionDeliberationSession2",
              title: <FormattedMessage id="mentionDeliberationPointSession2" />,
              type: "item",
              url: "/MentionDeliberationSession2",
            }, */

            {
              id: "controle__paiement_stop2",
              title: ["5. ",<FormattedMessage id="controle__paiement_stop_ecole" />],
              type: "item",
              url: "/PautaPaiementControleStop",
            },
              {
              id: "MultaCadastro2",
              title: ["7. ", <FormattedMessage id="multa_cadastro_titre" />],
              type: "item",
              url: "/MultaCadastro",
            },

            {
              id: "documentsEtudiantText1",
              title: ["8. ", <FormattedMessage id="documentsEtudiantText" />],
              type: "item",
              url: "/DocumentEtudiantEnregistrer",
            },
            
            {
              id: "hashTable1",
              title: ["9. ",<FormattedMessage id="total_liquidoi" />],
              type: "item",
              url: "/HashTableList",
            },
            {
              id: "passagem_classe_actualizar1",
              title: ["10. ",<FormattedMessage id="passagem_classe_actualizar" />],
              type: "item",
              url: "/resultado-passagem-classe-actualizar",
            },
            {
              id: "moienregistrer1",
              title: ["11. ", <FormattedMessage id="moienregistrer" />],
              type: "item",
              url: "/MonthRegister",
            },


          ],
        },

        {
          id: "instituition",
          title: <FormattedMessage id="instituition" />,
          type: "collapse",
          icon: IconHome2,
          children: [
            {
              id: "enregistrer_institution",
              title:  ["1. ", <FormattedMessage id="enregistrer_institution" />],
              type: "item",
              url: "/universityRegister",
            },
            {
              id: "listUniversites",
              title: ["2. ",<FormattedMessage id="list_institution" />],
              type: "item",
              url: "/universityList",
            },
          ],
        },

        {
          id: "faculte",
          title: <FormattedMessage id="ecole" />,
          type: "collapse",
          icon: GiPostOffice,
          children: [

        {
          id: "faculteEnregistre",
          title: ["1. ",<FormattedMessage id="enregistrer_ecole" />],
          type: "item",
          url: "/FacultyRegister",
        },
        {
          id: "listFacultes",
          title: ["2. ",<FormattedMessage id="list_ecole" />],
          type: "item",
          url: "/FacultyList",
        },
          ],
        },


        {
          id: "departement",
          title: <FormattedMessage id="cycle" />,
          type: "collapse",
          icon: FcDepartment,
          children: [


        {
          id: "departementEnregistre",
          title: ["1. ",<FormattedMessage id="enregistrer_cicle" />],
          type: "item",
          url: "/DepartementRegisterSchool",
        },

        {
          id: "listdepartement",
          title: ["2. ", <FormattedMessage id="lister_cycles" />],
          type: "item",
          url: "/DepartementList",
        },
          ],
        },

        {
          id: "cadastroUsarios",
          title: <FormattedMessage id="usuario" />,
          type: "collapse",
          icon: IconUser,
          children: [
            {
              id: "cadastroUsuarios",
              title: ["1. ",<FormattedMessage id="novo_usuario_menu" />],
              type: "item",
              url: "/UserRegister",
              // '/user/social-profile/posts'
            },

            {
              id: "listagemUsuarios",
              title: ["2. ",<FormattedMessage id="listagem_usuario_menu" />],
              type: "item",
              url: "/UserList",
              // '/user/social-profile/posts'
            },
            {
              id: "mudarsenha",
              title: ["3. ", <FormattedMessage id="mudar__senha__apagar__conta__menuItem" />],
              type: "item",
              url: "/UserMudarSemha",
              // '/user/social-profile/posts'
            },

            {
              id: "utilisateurs-enligne",
              title: ["4. ", <FormattedMessage id="utilisateur__connectes" />],
              type: "item",
              url: "/utilisateurs/enligne",
              // '/user/social-profile/posts'
            },

            {
              id: "chat_room1",
              title: ["5. ",<FormattedMessage id="chat_room" />],
              type: "item",
              url: "/chat/users/app/form'",
            },
            
          
          ],
        },

        {
          id: "cadastroPaisesECidade",
          title: <FormattedMessage id="paisesECidade" />,
          type: "collapse",
          icon: IconGlobe,
          children: [
            {
              id: "enregistrer_paiys1",
              title: ["1. ", <FormattedMessage id="enregistrer_paiys" />],
              type: "item",
              url: "/PaisECidade",
              // '/user/social-profile/posts'
            },

            {
              id: "enregistrer_cidade1",
              title: ["2. ",<FormattedMessage id="enregistrer_cidade" /> ],
              type: "item",
              url: "/PaisECidade2",
              // '/user/social-profile/posts'
            },

          ],
        },

        {
          id: "cadastrarPrivilegios",
          title: <FormattedMessage id="privilegios_visualizar" />,
          type: "collapse",
          icon: IconKey,
          children: [
            {
              id: "privilegeGeral",
              title: ["1. ",<FormattedMessage id="privilegeGeral" />],
              type: "item",
              url: "/privileges/administrationSchools",
              // url: "/usuarios/privilegios",
            },
            {
              id: "privilegeEtudiantsSchool1",
              title: ["2. ",<FormattedMessage id="privilegeEtudiantsSchool" />],
              type: "item",
              url: "/privileges/etudiants",
            },
            {
              id: "privilegeprofesseurs1",
              title: ["3. ", <FormattedMessage id="privilegeprofesseurs1School" />],
              type: "item",
              url: "/privileges/professeursSchools",
            },
            {
              id: "privilegesCours1",
              title: ["4. ",<FormattedMessage id="privilesCours" />],
              type: "item",
              url: "/privileges/cours",
            },

            {
              id: "privilegesPaiement1",
              title: ["5. ",<FormattedMessage id="privilegesPaiement" />],
              type: "item",
              url: "/privileges/pagamento",
            },
            {
              id: "privilegeCaisse1",
              title: ["6. ",<FormattedMessage id="privilegeCaisse1" /> ],
              type: "item",
              url: "/privileges/caixa",
            },
                        
          ],
        },

        /*   {
            id: "cadastrarMails",
            title: <FormattedMessage id="mail_e_notificacao_visualizar" />,
            type: "collapse",
            icon: icons.IconBasket,
            children: [
              {
                id: "mailsRead",
                title: <FormattedMessage id="mail_e_notificacao" />,
                type: "item",
                url: "/user/notifications/read",
              },
            ],
          }, */

          {
            id: "DeclarationEffet",
            title: ["1. ",<FormattedMessage id="declracao_efeito" />],
            type: "item",
            url: "/declaracao/effetDeclaracao",
          },
           {
            id: "declaracao_assinante1",
            title: ["2. ",<FormattedMessage id="declaracao_assinante" />],
            type: "item",
            url: "/declaracao/assinante",
          },

          {
            id: "numero_declaracao_config1",
            title: ["3. ",<FormattedMessage id="numero_declaracao_config" />],
            type: "item",
            url: "/declaracao/NumeroDeclaration",
          },
    
  ],
};

  



export default applicationEcoles;
